import { Box, Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";

interface WorkflowAssetTableAssetCellProps {
  value: string;
  url: string;
}

export default function WorkflowAssetTableAssetCell({
  value,
  url,
}: WorkflowAssetTableAssetCellProps) {
  const linkProps = url ? { component: Link, to: url } : {};

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        height: "100%",
      }}
    >
      <Stack direction="column" justifyContent="center" gap={1}>
        <Box sx={{ display: "flex", alignItems: "center", flex: "1 0 0" }}>
          <Typography
            variant="body2"
            {...linkProps}
            sx={{ fontWeight: "bold" }}
          >
            {value}
          </Typography>
        </Box>
        {/* Tags not implemented on backend yet */}
        {/* <Box
          sx={{
            display: "flex",
            alignItems: "center",
            alignSelf: "stretch",
            gap: 1,
            height: 24,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
              flex: "1 0 0",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: 0.5,
                borderRadius: 1,
                background: "#F7F7F8", // TODO: background.default
                gap: 0.25,
              }}
            >
              <Typography
                variant="caption"
                sx={{ lineHeight: "14px", color: "text.secondary" }}
              >
                key
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  lineHeight: "14px",
                  fontWeight: "bold",
                  color: "text.secondary",
                }}
              >
                value
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  lineHeight: "14px",
                  fontWeight: "bold",
                  color: "text.disabled",
                }}
              >
                33
              </Typography>
            </Box>
          </Box>
        </Box> */}
      </Stack>
    </Box>
  );
}
